import "styles/index.css";
import "moment/locale/th";

import * as serviceWorker from "src/serviceWorker";
import { initFacebookSdk } from "./helper/facebook";

import { Route, Router, Switch } from "react-router-dom";

import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import configureStore from "reducers/configureStore";
import history from "services/history";
import i18n from "src/translations/i18n";
import rootSaga from "sagas";
import routes from "src/routes";
import Layout from "src/layout/main";
import "./tailwindOutput.css"; // Import your Tailwind CSS here

const store = configureStore(/* provide initial state if any */);
store.runSaga(rootSaga);

initFacebookSdk().then(() => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            {routes.map((rawRoute) => {
              const { notExact, noHeader, ...route } = rawRoute;
              return noHeader ? <Route key={route.path} exact={!notExact} {...route} /> : null;
            })}
            <Layout>
              {routes.map((rawRoute) => {
                const { notExact, noHeader, ...route } = rawRoute;
                return !noHeader ? <Route key={route.path} exact={!notExact} {...route} /> : null;
              })}
            </Layout>
          </Switch>
        </Router>
      </Provider>
    </I18nextProvider>,
    document.getElementById("root"),
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
